class IncludeCapitalLetter {
    validate(data) {
        return {
            isValid: /[A-Z]/.test(data),
        };
    }
}
export default IncludeCapitalLetter;
